import { useTranslation } from 'react-i18next';
import { Field, Input } from '@digitalisation/enlixy-comp';
import { KPIS, type Kpi, type ResolvedTarget } from '../../services/KpiTargetService';
import type { TargetInputs } from './kpiTargetForm';

/**
 * The six target fields of one level (machine, line or machine type). An
 * empty field shows what applies instead (from the next level) as placeholder;
 * `hints` explain a field's unit at this level (e.g. what output counts).
 */
export function KpiTargetFields({
  id,
  inputs,
  onChange,
  inherited,
  invalid,
  disabled,
  hints,
}: {
  id: string;
  inputs: TargetInputs;
  onChange: (kpi: Kpi, value: string) => void;
  inherited?: Partial<Record<Kpi, ResolvedTarget>>;
  invalid?: Kpi | null;
  disabled?: boolean;
  hints?: Partial<Record<Kpi, string>>;
}) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {KPIS.map((kpi) => {
        const from = inherited?.[kpi];
        const fieldId = `${id}-${kpi}`;
        return (
          <Field key={kpi} label={t(`kpiTargets.${kpi}`)} htmlFor={fieldId} hint={hints?.[kpi]}>
            <Input
              id={fieldId}
              inputMode="decimal"
              value={inputs[kpi]}
              onChange={(e) => onChange(kpi, e.target.value)}
              placeholder={
                from ? t('kpiTargets.inherited', { value: from.value, source: t(`kpiTargets.from.${from.scope}`) }) : '–'
              }
              invalid={invalid === kpi}
              disabled={disabled}
            />
          </Field>
        );
      })}
    </div>
  );
}
